import { render, staticRenderFns } from "./ContentPageArea.vue?vue&type=template&id=1aa78de0"
import script from "./ContentPageArea.vue?vue&type=script&lang=js"
export * from "./ContentPageArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports